/** Armazenamento de Essences (separado de itens/equipamentos). */
import { type EssenceType, ESSENCE_TYPES } from "./EssenceTypes";

export class EssenceInventory {
  private counts: Record<EssenceType, number> = {
    power: 0,
    vitality: 0,
    agility: 0,
    fortitude: 0,
    ferocity: 0,
  };

  get(type: EssenceType): number {
    return this.counts[type];
  }

  add(type: EssenceType, n: number): void {
    this.counts[type] += n;
  }

  /** Gasta se houver o suficiente; retorna false caso contrário. */
  spend(type: EssenceType, n: number): boolean {
    if (this.counts[type] < n) return false;
    this.counts[type] -= n;
    return true;
  }

  total(): number {
    let t = 0;
    for (const type of ESSENCE_TYPES) t += this.counts[type];
    return t;
  }

  snapshot(): Record<EssenceType, number> {
    return { ...this.counts };
  }

  load(data: Partial<Record<EssenceType, number>> | undefined): void {
    for (const type of ESSENCE_TYPES) {
      this.counts[type] = Math.max(0, Math.floor(data?.[type] ?? 0));
    }
  }

  reset(): void {
    for (const type of ESSENCE_TYPES) this.counts[type] = 0;
  }
}
